
import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { purchaseList, PURCHASE_LIST_UPDATED } from '@/collections/purchase_list';
import { EventBus } from '@/eventBus';
import { StoreModel } from '@/models/store';
import { hasPurchaseListAccess } from './purchaseListAccess';

export { hasPurchaseListAccess };

@Component({})
export default class PurchaseListIcon extends Vue {
  @Inject({ default: null })
  public readonly store!: StoreModel | null;

  @Prop({ type: Boolean, default: false })
  public readonly iconOnly!: boolean;

  public count = 0;

  public get visible(): boolean {
    return hasPurchaseListAccess({
      store: this.store,
      permissionService: this.$permissionService,
      initializing: Vue.prototype.$permissionsInitializing === true,
    });
  }

  public get ariaLabel(): string {
    return typeof (this as any).$t === 'function'
      ? ((this as any).$t('purchase_list.navbar.aria') as string)
      : 'Purchase list';
  }

  public get label(): string {
    return this.ariaLabel;
  }

  public mounted(): void {
    EventBus.$on(PURCHASE_LIST_UPDATED, this.refresh);
    void this.refresh();
  }

  public beforeDestroy(): void {
    EventBus.$off(PURCHASE_LIST_UPDATED, this.refresh);
  }

  public async refresh(): Promise<void> {
    if (!this.visible) { this.count = 0; return; }
    try {
      this.count = await purchaseList.getCount();
    } catch {
      this.count = 0;
    }
  }

  public onClick(): void {
    if (this.$route.path !== '/purchase-orders/purchase-list/review') {
      void this.$router.push('/purchase-orders/purchase-list/review');
    }
  }
}
